import Resizable, {NumberSize, ResizableDirection} from "re-resizable";
import * as _ from "lodash";
import {Icon} from "semantic-ui-react";
import * as React from "react";
import {IVirtualizedTableColumn, ILocalColumnSizeSettings, TDerivate} from "../../../VirtualizedTableInterfaces";
import VirtualizedTableHeaderFilter from "./VirtualizedTableHeaderFilter";

const resizeEnabled = {top: false, right: true, bottom: false, left: false, topRight: false, bottomRight: false, bottomLeft: false, topLeft: false};

interface VirtualizedTableHeaderCellProps {
    t: reactI18Next.TranslationFunction;
    isAscending?: boolean;
    hasDropdown: boolean;
    visibleColumn: IVirtualizedTableColumn;
    style: React.CSSProperties;
    columnSizeSetting: ILocalColumnSizeSettings;
    dropdownFilters?: {
        [key: string]: Set<string>,
    };
    filterValue: {[key: string]: any};
    setState: (newColumnWidth: ILocalColumnSizeSettings) => void;
    onSort?: (key: string, isAscending: boolean) => void;
    onFilterChange: (key: string, value: string | boolean | TDerivate | Set<string>) => void;
    isTallHeader?: boolean;
}

const VirtualizedTableHeaderCell: React.SFC<VirtualizedTableHeaderCellProps> = (props: VirtualizedTableHeaderCellProps) => {
    const {
        t,
        style,
        filterValue,
        dropdownFilters,
        hasDropdown,
        visibleColumn,
        columnSizeSetting,
        isAscending,
        onSort,
        onFilterChange,
        setState,
        isTallHeader,
    } = props;

    return (
        <div
            className='grid-header-cell grid-border-top grid-border-right grid-border-bottom'
            style={style}
        >
            <Resizable
                className={`resize-cell-vertical-bar ${isTallHeader ? 'tall-table-header-height' : 'short-table-header-height'}`}
                enable={resizeEnabled}
                size={{width: columnSizeSetting[visibleColumn.key] ? columnSizeSetting[visibleColumn.key].width : 100}}
                minWidth={visibleColumn.options ? visibleColumn.options.cellWidth : 100}
                onResizeStop={(event: MouseEvent | TouchEvent, direction: ResizableDirection, elementRef: HTMLDivElement, size: NumberSize) => {
                    let columnSizeSettingCopy = _.cloneDeep(columnSizeSetting);
                    const currentWidth = columnSizeSettingCopy[visibleColumn.key].width;
                    columnSizeSettingCopy[visibleColumn.key] = {width: currentWidth ? currentWidth + size.width : size.width};
                    setState(columnSizeSettingCopy);
                }}
            />
            <div className='grid-header-content-cell' style={{top: isTallHeader ? 40 : 10}}>
                {visibleColumn.options && visibleColumn.options.isSortable && onSort &&
                    <React.Fragment>
                        <Icon
                            link={true}
                            onClick={() => onSort(visibleColumn.key, true)}
                            color={isAscending === true ? "green" : undefined}
                            name="sort alphabet down"
                        />
                        <Icon
                            link={true}
                            onClick={() => onSort(visibleColumn.key, false)}
                            color={isAscending === false ? "green" : undefined}
                            name="sort alphabet up"
                        />
                    </React.Fragment>
                }
                {visibleColumn.label}
                <VirtualizedTableHeaderFilter
                    t={t}
                    columnKey={visibleColumn.key}
                    isDropdown={hasDropdown}
                    dropdownFilters={dropdownFilters}
                    filterValue={filterValue}
                    onFilterChange={onFilterChange}
                />
            </div>
        </div>
    );
};

export default VirtualizedTableHeaderCell;



// WEBPACK FOOTER //
// ./src/components/Table/components/headerComponents/virtualizedTableHeaderCell/VirtualizedTableHeaderCell.tsx